import { render, staticRenderFns } from "./user_avatar.vue?vue&type=template&id=516843c6&scoped=true&"
import script from "./user_avatar.vue?vue&type=script&lang=js&"
export * from "./user_avatar.vue?vue&type=script&lang=js&"
import style0 from "./user_avatar.vue?vue&type=style&index=0&id=516843c6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "516843c6",
  null
  
)

export default component.exports